import React from 'react';
import {
  useHistory
} from "react-router-dom";
import QRious from 'qrious';
import FileSaver from 'file-saver';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
// import Pagination from '@material-ui/lab/Pagination';
// import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
// import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import CircularProgress from '@material-ui/core/CircularProgress';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import Snackbar from '@material-ui/core/Snackbar';

import Config from '../config';
import { Button } from '@material-ui/core';
import AdminHeaderDrawer from '../AdminHeaderDrawer';
import dataURItoBlob from '../utils/dataURItoBlob';
import templateVerticalImg from './checkin.png';



interface StoreProfileType {
  id: string;
  name: string;
  logoImgUrl?: string;
}

export const verticalSize = {
  canvasSize: {
    x: 1679,
    y: 2382,
  },
  qrSize: 860,
  qr: {
    x: 410,
    y: 1300,
  },
  fontSize: 200,
  font: {
    x: 620,
    y: 450,
  },
};
const {
  canvasSize: {
    x: canvasX,
    y: canvasY,
  },
  qr: {
    x: qrX,
    y: qrY,
  },
  font: {
    x: fontX,
    y: fontY,
  },
  fontSize,
  qrSize,
} = verticalSize;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
  },
  container: {
    marginTop: 60,
  },
  title: {
    flexGrow: 1,
    // color: 'white'
  },
  wraper: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 10,
    paddingBottom: 10,
  },
  center: {
    textAlign: 'center',
  },
  name: {
    padding: 30,
    fontSize: 30,
  },
  card: {
    // paddingBottom:0,
  },
  download: {
    marginTop: 15,
  }
}));

const StoreProfile = () => {
  const classes = useStyles();
  const history = useHistory();
  const [storeDetail, setStoreDetail] = React.useState<StoreProfileType>();
  const [qrcodePreviews, setQrcodePreviews] = React.useState<any>();
  const [fetching, setFetching] = React.useState<boolean>(true);
  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>();

  React.useEffect(() => {
    if (!localStorage.getItem('accessToken') || !localStorage.getItem('storeId')) history.push('/login');
    fetchStoreDetail(localStorage.getItem('storeId') || '');
  }, []);

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const fetchStoreDetail = async (storeId: string) => {
    try {
      setFetching(true);
      const res = await fetch(`${Config.apiUrl}store/v1/profile/${storeId}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('accessToken') || '',
          },
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      const result = await res.json();
      setStoreDetail(result);
      generateRegistrationQRCode(result);

    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    } finally {
      setFetching(false);
    }
  };

  const generateRegistrationQRCode = async (store: StoreProfileType) => {
    const qrcode = new QRious();
    qrcode.set({
      value: generateCustomerRegisiterUrl(store?.id || ''),
      size: qrSize,
    });
    const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
    canvas.setAttribute('id', 'templateCanvas');
    canvas.hidden = true;
    canvas.height = canvasY;
    canvas.width = canvasX;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(canvas, 0, 0);
    const background = new Image();
    background.onload = () => {
      const qrData = qrcode.toDataURL('image/jpeg');
      const qrImg = new Image();
      qrImg.onload = () => {
        ctx?.drawImage(background, 0, 0);
        ctx?.drawImage(qrImg, qrX, qrY);
        setQrcodePreviews(canvas.toDataURL('image/jpeg'));
      };
      qrImg.src = qrData;
    };
    background.src = templateVerticalImg;
  }

  const downloadRegistrationQRCode = async () => {
    FileSaver.saveAs(dataURItoBlob(qrcodePreviews), `CustomerRegisiterQRcode.jpg`);
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <AdminHeaderDrawer />
          <Typography variant="h6" className={classes.title}>
            Check-in QR Code
          </Typography>
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>
        {fetching && <div className={classes.center}><CircularProgress color="primary" /></div>}
        {!fetching &&
          <React.Fragment>
            <div className={classes.center}>
              <Typography className={classes.name} variant="h6" component="h1">
                {storeDetail?.name}
              </Typography>
              <Card variant="outlined" className={classes.card}>
                <CardContent>
                <Typography variant="body1" component="h1">
                Customer Check-in QR Code
              </Typography>
                  <img alt="" src={qrcodePreviews} style={{ width: '100%', marginTop: 10, }} />
                  <Button variant="outlined" className={classes.download} onClick={downloadRegistrationQRCode}>Download</Button>
                </CardContent>
              </Card>
            </div>
          </React.Fragment>
        }
      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        message={errorMessage}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
};

const generateCustomerRegisiterUrl = (storeId: string) => {
  return encodeURI(`${Config.customerRegisiterDomain}${storeId}`);
}

export default StoreProfile;